import React from 'react'
import watsIcon from '../assest/home/5357b4eb16238760df0ba166628f1cee41086e44.png';
import { Link } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import '../css/AllServices.css';
function SupportServices() {
    const serviceRefs = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-in');
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1, // يتم التنشيط عندما يكون 10% من العنصر مرئيًا
                rootMargin: '0px 0px -50px 0px' // يتم التنشيط قبل 50px من وصول العنصر
            }
        );

        serviceRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            serviceRefs.current.forEach((ref) => {
                if (ref) observer.unobserve(ref);
            });
        };
    }, []);

    // دالة لإضافة العناصر إلى المصفوفة المرجعية
    const addToRefs = (el, index) => {
        if (el && !serviceRefs.current.includes(el)) {
            serviceRefs.current[index] = el;
        }
    };

    return (
        <div className="services-name">
            <div className='training' ref={(el) => addToRefs(el, 0)}>
                <h1>خدمة التدريب والتأهيل</h1>
                <div>
                    <Link to='/services/TrainQualif'>التفاصيل</Link>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966561103887?text= السلام عليكم. اريد استفسر عن خدمة التدريب والتاهيل'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className='eng-consultation' ref={(el) => addToRefs(el, 1)}>
                <h1>خدمات الاستشارات الهندسية</h1>
                <div>
                    <Link to={'/services'}>التفاصيل</Link>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966561103887?text=السلام عليكم. اريد استفسر عن خدمة هندسية'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className='health-Insurance' ref={(el) => addToRefs(el, 2)}>
                <h1>خدمات التأمين الصحي الشامل</h1>
                <div>
                    <span><Link to='/services/medicalservices'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966561103887?text=السلام عليكم. عندس استفسار عن خدمات التامين الصحي الشامل'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className='saber-service' ref={(el) => addToRefs(el, 3)}>
                <h1>خدمات سابر</h1>
                <div>
                    <span><Link to='/services/saberservices'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966561103887?text=السلام عليكم. عندس استفسار عن خدمات سابر'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className='ministry-interior' ref={(el) => addToRefs(el, 4)}>
                <h1>خدمات وزارة الداخلية</h1>
                <div>
                    <span>التفاصيل</span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966561103887?text=السلام عليكم. اريد استفسر عن خدمات وازارة الداخلية'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className='najiz-service' ref={(el) => addToRefs(el, 5)}>
                <h1>خدمات منصة ناجز</h1>
                <div>
                    <span><Link to='/services/najizServices'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966561103887?text=السلام عليكم. اريد استفسر عن خدمات منصة ناجز'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className='madad-service' ref={(el) => addToRefs(el, 6)}>
                <h1>خدمات منصة مدد</h1>
                <div>
                    <span><Link to='/services/madad'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966561103887?text=السلام عليكم اريد استفسر عن خدمات منصة مدد'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className='civil-defense' ref={(el) => addToRefs(el, 7)}>
                <h1>خدمات الدفاع المدني</h1>
                <div>
                    <span><Link to="/services/civilservices">التفاصل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966561103887?text=السلام عليكم. لدي استفسار عن خدمات الدفاع المدني'>أطلب الان</Link>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default SupportServices

// ٍSupport Services > الخدمات المساندة